import { useStacklineTheme } from '@stackline/ui';
import { useMemo } from 'react';

/**
 * Returns a color based on the percent value.
 * @param percent number between 0 and 1 or 0 and 100
 */
export const useColorForPercentage = (percent: number) => {
  const theme = useStacklineTheme();

  const color = useMemo(() => {
    // Normalize percent to 0-1 range if it's in 0-100 range
    const normalizedPercent = percent > 1 ? percent / 100 : percent;
    return normalizedPercent >= 0.7
      ? theme.colors.success
      : normalizedPercent < 0.5
      ? theme.colors.error
      : theme.colors.accentGold;
  }, [percent, theme.colors]);

  return color;
};
